enum FormInputTypeEnum {
  string = 'string',
  text = 'text',
  checkbox = 'checkbox',
  select = 'select',
  secure = 'secure',
  reference = 'reference',
  number = 'number',
  boolean = 'boolean',
  file = 'file',
  object = 'object',
  datetime = 'datetime',
  date = 'date',
  submit = 'submit',
  /**
   * Dont' use this type it needs to be retired.
   * It's for the PageController
   * @deprecated
   */
  button = 'button',
}

type FormInputValidation = {
  algorithm: 'email' | 'range' | 'select' | 'checkbox';
  min?: number;
  max?: number;
  requirement?: string;
};

type FormInputChange = {
  id: string;
  value: any;
  validation?: FormInputValidation;
  type: FormInputTypeEnum;
};

type OnClickData = { successActions?: any; route?: string };

type FormInputValues = {
  id: string;
  value: any;
  type: string;
  managedUpdateForm?: boolean;
};

type OnClick = (evt: any, data?: OnClickData, formInputsValues?: FormInputValues[]) => void;

type FormInputProps = {
  value: any;
  classNameOverride?: string;
  label: string;
  id: string;
  validation?: FormInputValidation;
  isDisabled?: boolean;
  isLoading?: boolean;
  type: FormInputTypeEnum;
  tooltipQuestion?: string;
  formInputOnChange: (change: FormInputChange, notifyParent?: boolean) => void;
  multiSelectEnabled?: boolean;
  requireValidForm?: boolean;
  rowClassName: string;
  required?: boolean | string;
  placeholder?: string;
  element: string;
  options?: { value: string; text: string }[];
  tooltip?: string;
  errorMessage: string;
  reference?: string;
  row?: number;
  col?: number;
  key?: string;
  title?: string;
  to?: string;
  text?: string;
  route?: string;
  successActions?: any;
  onClick?: OnClick;
  onClickWrapper?: (onClick: OnClick, evt: any, data?: OnClickData) => void;
};

type FormValidatedRef = {
  getValueFor: (id: string) => string;
  /**
   * Example of when to use this is in the ModelManager when we change schema fields
   * If the schema field is of the same "type" then the form input ID's won't change, but all the values will.
   * So we must then notify the form to update its internal state in that scenario.
   *
   * Use this method to do that.
   */
  reset: () => void;
};

type FormInputType = {
  label: string;
  class?: string;
  element: string;
  options?: any;
  placeholder?: string;
  validation?: FormInputValidation;
  requireValidForm?: boolean;
  row?: number;
  col?: number;
  id: string;
  type: FormInputTypeEnum;
  onClick?: OnClick;
  required?: string;
  value: any;
  to?: string;
  text?: string;
  managedUpdateForm?: boolean;
  key?: string;
  multiSelectEnabled?: boolean;
  reference?: string;
};

type FormInputValuesMap = {
  [key: string]: {
    value: any;
    /**
     * Used by buttons to disable
     */
    isDisabled?: boolean;
    error?: string | undefined;
  };
};

type FormValidatedProps = {
  columns: number;
  dynamicInputs: boolean;
  formClassName?: string;
  formInputs: FormInputType[];
  formOnChange: (change: FormInputChange, isFormValid: boolean) => void;
  validateOnInit: boolean;
  description: string;
};

export type {
  FormInputChange,
  FormInputProps,
  FormInputValidation,
  FormInputValues,
  FormInputType,
  FormInputValuesMap,
  FormValidatedProps,
  FormValidatedRef,
};

export { FormInputTypeEnum };
